import { LoadingButton } from "@mui/lab";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    InputAdornment,
    useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import {
    InputCurrency,
    InputText,
    setTitleCase,
} from "app/components/template/partials";
import { STATUS } from "configs/constant";
import { Field, Formik } from "formik";
import { useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { doneSchedule, notifyCustomer } from "utils/action";
import { AESDecryptURL } from "utils/encryption/AESDecrypt";
import * as Yup from "yup";

// inital values form
const initialValues = (autoComplete) => {
    return {
        bill: autoComplete?.tagihan ?? "",
        volume_tangki_septik: autoComplete?.volume_tangki_septik ?? "",
        tangki_septic_location: autoComplete?.lokasi_tangki_septik ?? {
            latitude: "",
            longitude: "",
        },
    };
};

// form field validation schema
const validationSchema = Yup.object().shape({
    bill: Yup.number().required("Tagihan wajib diisi!"),
    volume_tangki_septik: Yup.number().required(
        "Volume Tangki Septik wajib diisi!"
    ),
    // tangki_septic_location: Yup.object().shape({
    //   latitude: Yup.string().required("Lokasi Tangki Septik wajib diisi!"),
    //   longitude: Yup.string().required("Lokasi Tangki Septik wajib diisi!"),
    // }),
});

export function CustomerConfirmDoneDialog() {
    const location = useLocation();
    const navigate = useNavigate();
    const theme = useTheme();
    const [isLoading, setLoading] = useState(false);
    const { id } = useParams();
    const showDialog = location.state?.showDialog ?? false;
    const scheduleData = location.state?.scheduleData ?? null;
    const customerData = location.state?.customerData ?? null;
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
    const decID = parseInt(AESDecryptURL(id));

    const onHide = () => {
        navigate(-1);
    };

    const handleFormSubmit = async (values) => {
        setLoading(true);
        const request = {
            id: scheduleData.id,
            id_pelanggan: decID,
            tagihan: values?.bill,
            volume_disedot: values.volume_disedot,
            lokasi_tangki: values.tangki_septic_location,
        };

        const requestNotif = {
            status: STATUS.DONE_CLEANING,
        };

        // send to backend
        try {
            await doneSchedule(request);
            const response = await notifyCustomer(decID, requestNotif);
            window.open(response.data?.redirect, "_blank");
            toast.success(setTitleCase("berhasil menyelesaikan jadwal"));
        } catch (error) {
            toast.error(setTitleCase(error.response.data?.message));
        }
        setLoading(false);
        onHide();
    };

    return (
        <Dialog
            fullScreen={fullScreen}
            fullWidth
            open={showDialog}
            onClose={onHide}
            aria-labelledby="responsive-dialog-customer-confirm-done-title"
        >
            <DialogTitle id="responsive-dialog-customer-confirm-done-title">
                Konfirmasi Telah Selesai Dibersihkan
            </DialogTitle>
            <Divider />
            <Formik
                enableReinitialize
                onSubmit={handleFormSubmit}
                initialValues={initialValues(customerData)}
                validationSchema={validationSchema}
            >
                {({ handleSubmit, values }) => (
                    <form onSubmit={handleSubmit}>
                        <DialogContent>
                            <Grid container spacing={3}>
                                <Grid item md={6} xs={12}>
                                    <Field
                                        component={InputCurrency}
                                        name="bill"
                                        label="Tagihan"
                                        size="small"
                                        variant="outlined"
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item md={6} xs={12}>
                                    <Field
                                        component={InputText}
                                        name="volume_disedot"
                                        label="Volume Yang Disedot"
                                        size="small"
                                        variant="outlined"
                                        type="number"
                                        fullWidth
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    m³
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Grid>
                                <Grid item md={6} xs={6}>
                                    <Field
                                        component={InputText}
                                        name="tangki_septic_location.latitude"
                                        label="Lokasi Tangki Septik"
                                        size="small"
                                        variant="outlined"
                                        type="text"
                                        fullWidth
                                        multiline
                                        maxRows={4}
                                    />
                                </Grid>
                                <Grid item md={6} xs={6}>
                                    <Field
                                        component={InputText}
                                        name="tangki_septic_location.longitude"
                                        label="Lokasi Tangki Septik"
                                        size="small"
                                        variant="outlined"
                                        type="text"
                                        fullWidth
                                        multiline
                                        maxRows={4}
                                    />
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <Divider />
                        <DialogActions>
                            <Button
                                autoFocus
                                onClick={onHide}
                                color="error"
                                variant="contained"
                            >
                                Batal
                            </Button>
                            <LoadingButton
                                autoFocus
                                loading={isLoading}
                                type="submit"
                                color="primary"
                                variant="contained"
                            >
                                Simpan
                            </LoadingButton>
                        </DialogActions>
                    </form>
                )}
            </Formik>
        </Dialog>
    );
}
